import { Action } from '@ngrx/store';

export const LOGOUT = '[Auth] Logout';
export const REDIRECT = '[Auth] Redirect';

/**
 * Action exposed to clear store after logout.
 */
export class LogoutAction implements Action {
    readonly type = LOGOUT;
}

export class RedirectAction implements Action {
    readonly type = REDIRECT;

    constructor(public payload: string) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions = LogoutAction | RedirectAction;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/actions/logout.actions.ts